import { NgModule }  from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AuthGuard } from './services/firebase/firebase.service';


//Paginas
import { HomePage,PostPage,LoginPage,WritePage,NotFoundExceptionPageComponent,ErrorPage } from './pages/pages';

const appRoutes: Routes = [
	{ path: '', component: HomePage },
	{ path: 'post/:id', component: PostPage },
	{ path:'login', component: LoginPage},
	{ path:'write', component: WritePage,canActivate: [AuthGuard]},
  { path:'error',component: ErrorPage},
  { path:'404',component: NotFoundExceptionPageComponent},
  { path: '**',redirectTo: '404', pathMatch: 'full' }
];


@NgModule({
  imports: [
    RouterModule.forRoot(
      appRoutes,
      { enableTracing: false } // <-- debugging purposes only
    )
  ],
  exports: [
    RouterModule
  ]
})
export class AppRoutingModule {}